import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardPhotoWrapper } from './PropertyCardPhotoWrapper.styles';

/**
 * Used by a `PropertyCard` to contain all of the parts of the property photo area
 * including the photo, badges and MLS information.
 *
 * @since 8.63.0
 */
export var PropertyCardPhotoWrapper = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardPhotoWrapper, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardPhotoWrapper.displayName = 'PropertyCard.PhotoWrapper';